<template>
    <div class="generic-modal-container" v-if="!hidden" @click="bgClicked" :class="{
        opened: !hidden,
        'bg-clip-padding bg-gray-50 backdrop-filter bg-opacity-50': !hidden,
        opaque: isOpaque
    }">
        <div class="generic-modal">
            <div class="overflow-y-scroll" style="height: 75vh">
                <fs v-if="filesystemId" :filesystem-id="filesystemId"></fs>
            </div>
        </div>
    </div>
</template>

<script>

import {PackageNew} from "@models";

export default {
    components: {},
    props: {
        isOpaque: true,
        defaultFilesystemReference: '',
    },
    data() {
        return {
            hidden: true,
            filesystemId: false,
        }
    },
    computed: {},
    methods: {
        closeModal() {
            window.Bus.emit('close-package-filesystem')
            this.hidden = true;
        },
        openModal() {
            window.Bus.emit('close-all-slideovers');
            this.hidden = false;
        },
        bgClicked(e) {
            if (e.target.classList.contains('generic-modal-container')) {
                this.closeModal();
            }
        },
        resizeListener(e) {
            if (window.innerWidth <= 830) {
                if (!this.hidden) {
                    this.closeModal();
                }
            }
        },
        keydownListener(e) {
            if (e.ctrlKey || e.metaKey) {
                return;
            }
            if (e.keyCode === 27) {
                if (!this.hidden) {
                    this.closeModal()
                }
            }

            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(e.target.tagName)) {
                return;
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(document.activeElement.tagName)) {
                return;
            }

            if ((e.key === 'f') || (e.key === 'F')) {
                if (!this.hidden) {
                    this.closeModal()
                } else {
                    window.Bus.emit('show-package-filesystem', this.defaultFilesystemReference)
                }
                e.preventDefault();
                e.stopPropagation();
            }
        }
    },
    async mounted() {
        window.Bus.on('show-package-filesystem', (reference) => {
            PackageNew.findEstimation(reference).then(async (result) => {
                this.filesystemId = result.filesystemId
                this.openModal()
            })
        })
        window.addEventListener('keydown', this.keydownListener)
        window.Bus.on('close-all-slideovers', (reference) => {
            this.closeModal()
        })
        window.addEventListener('resize', this.resizeListener)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeListener)
        window.removeEventListener('keydown', this.keydownListener)
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/setup';

.generic-modal-container {
    display: none;

    &.opened {
        position: absolute;
        min-height: 100vh;
        width: 100vw;
        z-index: 100000;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        padding: 2em;
        @include desktop() {
            &.opaque {
                background-color: rgba(255, 255, 255, 1);
            }
        }
    }
}

.generic-modal {
    padding: 1em;
    @include grid-column(12);
    @include clearfix();
    @include desktop() {
        background-color: #fff;
        border-radius: 0.5em;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
        @include grid-column(8);
        min-width: 75vw;
        padding: 2em;
    }

    div.actions {
        text-align: left;
        margin-top: 30px;

        a, input[type="submit"] {
            padding: 0.7em 0.7em 0.8em;
            text-decoration: none;
            color: #fff;
            border-radius: $standardBorderRadius;
        }

        input[type="submit"] {
            background-color: $green;
        }

        a {
            background-color: #999;
        }

        a.success {
            background-color: $green;
        }

        @include desktop() {
            float: right;
            text-align: right;
        }
    }
}
</style>
